import { html, KompisElement, property } from '@inter-ikea-kompis/web-component';
import { ThemeFontStyleTypeEnum } from '@inter-ikea-kompis/enums';
import { FontStyle } from '@inter-ikea-kompis/themes';
import type { ITheme } from '@inter-ikea-kompis/types';
import type { RenderResult } from '@inter-ikea-kompis/web-component';

export default class Text extends KompisElement {
	// A flag preventing the stylesheet to be added more than once
	public static hasAddedStylesheet = false;

	// What type of text it is. e.g. bodyMedium, bodyLarge, bodyXLarge
	@property({ type: String })
	public type: ThemeFontStyleTypeEnum = ThemeFontStyleTypeEnum.bodyMedium;

	// Activate italic style
	@property({ type: Boolean })
	public italic = false;

	// Activate bold style
	@property({ type: Boolean })
	public bold = false;

	// Activate underline style
	@property({ type: Boolean })
	public underline = false;

	// Theme.
	@property({ type: Object, required: true })
	public theme!: ITheme;

	/**
	 * Renders the component.
	 *
	 * @returns Template.
	 */
	public override render(): RenderResult {
		if (!this.theme) {
			return html`<slot></slot>`;
		}
		return html`
			<style>
				slot, ::slotted(*) {
					text-decoration: inherit;
					color: inherit;
				}
				:host {
					display: inline;
					color: inherit;
				}
				${FontStyle.getStyle({
					type: this.type,
					italic: this.italic,
					bold: this.bold,
					underline: this.underline,
					theme: this.theme
				})}
			</style>
			<slot></slot>
		`;
	}
}
declare global {
	interface HTMLElementTagNameMap {
		'kompis-text': Text;
	}
}
